export default () => {
  return {
    editorIsPublishing: true
  }; 
};
